/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The member action this objective is completed through, as the objective's own explicit configuration — post links to like, an account to follow, a hashtag a submitted post must carry, a referral or serial config. Absent = scored automatically from the objective's trigger event; the back side is content only.
 * @export
 * @interface BoardEarnObjectiveAction
 */
export interface BoardEarnObjectiveAction {
    /**
     * The one post that pays right now (newest authored entry). Like objectives only — never an account link.
     * @type {Array<string>}
     * @memberof BoardEarnObjectiveAction
     */
    postUrls?: Array<string>;
    /**
     * The account the member follows, from the objective's url. Follow objectives only.
     * @type {string}
     * @memberof BoardEarnObjectiveAction
     */
    accountUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BoardEarnObjectiveAction
     */
    platforms?: Array<string>;
    /**
     * A submitted post must carry one — the verified-post action.
     * @type {Array<string>}
     * @memberof BoardEarnObjectiveAction
     */
    hashtags?: Array<string>;
    /**
     * The invite action.
     * @type {boolean}
     * @memberof BoardEarnObjectiveAction
     */
    referral?: boolean;
    /**
     * The serial-verification action.
     * @type {boolean}
     * @memberof BoardEarnObjectiveAction
     */
    serial?: boolean;
}

/**
 * Check if a given object implements the BoardEarnObjectiveAction interface.
 */
export function instanceOfBoardEarnObjectiveAction(value: object): value is BoardEarnObjectiveAction {
    return true;
}

export function BoardEarnObjectiveActionFromJSON(json: any): BoardEarnObjectiveAction {
    return BoardEarnObjectiveActionFromJSONTyped(json, false);
}

export function BoardEarnObjectiveActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoardEarnObjectiveAction {
    if (json == null) {
        return json;
    }
    return {
        
        'postUrls': json['postUrls'] == null ? undefined : json['postUrls'],
        'accountUrl': json['accountUrl'] == null ? undefined : json['accountUrl'],
        'platforms': json['platforms'] == null ? undefined : json['platforms'],
        'hashtags': json['hashtags'] == null ? undefined : json['hashtags'],
        'referral': json['referral'] == null ? undefined : json['referral'],
        'serial': json['serial'] == null ? undefined : json['serial'],
    };
}

export function BoardEarnObjectiveActionToJSON(json: any): BoardEarnObjectiveAction {
    return BoardEarnObjectiveActionToJSONTyped(json, false);
}

export function BoardEarnObjectiveActionToJSONTyped(value?: BoardEarnObjectiveAction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'postUrls': value['postUrls'],
        'accountUrl': value['accountUrl'],
        'platforms': value['platforms'],
        'hashtags': value['hashtags'],
        'referral': value['referral'],
        'serial': value['serial'],
    };
}

